import React from 'react';
import { Anchor, Phone, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy text-white pt-16 pb-8 border-t border-white/10" data-id="element-102">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-103">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-104">
          {/* Brand */}
          <div className="text-center md:text-left" data-id="element-105">
            <a href="#" className="inline-block mb-4 text-2xl font-heading font-bold uppercase tracking-tight" data-id="element-106">
              Diers and Stark, <span className="text-accent" data-id="element-107">Inc.</span>
            </a>
            <p className="text-gray-400 text-sm leading-relaxed max-w-xs mx-auto md:mx-0" data-id="element-108">
              Providing World-Class Service to the Marine Industry.
              NAMS-certified surveyors serving the Gulf Coast for over a century
              combined.
            </p>
          </div>

          {/* Quick Links */}
          <div className="text-center" data-id="element-109">
            <h4 className="text-sm font-bold uppercase tracking-widest text-accent mb-6" data-id="element-110">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-111">
              <li data-id="element-112">
                <a href="#home" className="text-gray-300 hover:text-white transition-colors text-sm uppercase tracking-wide" data-id="element-113">
                  Home
                </a>
              </li>
              <li data-id="element-114">
                <a href="#about" className="text-gray-300 hover:text-white transition-colors text-sm uppercase tracking-wide" data-id="element-115">
                  About Us
                </a>
              </li>
              <li data-id="element-116">
                <a href="#services" className="text-gray-300 hover:text-white transition-colors text-sm uppercase tracking-wide" data-id="element-117">
                  Services
                </a>
              </li>
              <li data-id="element-118">
                <a href="#contact" className="text-gray-300 hover:text-white transition-colors text-sm uppercase tracking-wide" data-id="element-119">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Small */}
          <div className="text-center md:text-right" data-id="element-120">
            <h4 className="text-sm font-bold uppercase tracking-widest text-accent mb-6" data-id="element-121">
              Contact
            </h4>
            <div className="flex flex-col items-center md:items-end space-y-3" data-id="element-122">
              <a href="tel:409-727-1607" className="flex items-center text-gray-300 hover:text-white transition-colors group" data-id="element-123">
                <span className="mr-2 text-sm" data-id="element-124">409-727-1607</span>
                <Phone className="w-4 h-4 text-accent group-hover:text-white" data-id="element-125" />
              </a>
              <a href="mailto:hstark@djs-marinesurveyors.com" className="flex items-center text-gray-300 hover:text-white transition-colors group" data-id="element-126">
                <span className="mr-2 text-sm" data-id="element-127">
                  hstark@djs-marinesurveyors.com
                </span>
                <Mail className="w-4 h-4 text-accent group-hover:text-white" data-id="element-128" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500 uppercase tracking-wider" data-id="element-129">
          <p className="mb-4 md:mb-0" data-id="element-130">
            © 2026 Diers and Stark, Inc. All rights reserved.
          </p>
          <div className="flex items-center" data-id="element-131">
            <Anchor className="w-4 h-4 mr-2 text-accent" data-id="element-132" />
            <span data-id="element-133">NAMS Certified Marine Surveyors</span>
          </div>
        </div>
      </div>
    </footer>;
}